import { StepCard } from 'pages/AutomationEngine/Engine/Steps/StepCard';
import { VariableDropzoneCard } from './VariableDropzoneCard';
import { type CardProps } from '../../types';
import { useIsVariableDropZone } from './useIsVariableDropZone';

export const VariableCard = ({
  step,
  panel = null,
  addMenu = true,
  onSelectMenu,
  id,
  ...props
}: CardProps) => {
  const isVariableDropZone = useIsVariableDropZone(step);

  const dropZoneProps = isVariableDropZone
    ? {
        addMenu: false,
        onSelectMenu: null,
        onStart: null,
        onStop: null,
      }
    : {};

  return (
    <StepCard
      id={step.id}
      panel={panel}
      addMenu={addMenu}
      onSelectMenu={onSelectMenu}
      leading={isVariableDropZone ? <VariableDropzoneCard step={step} /> : null}
      {...props}
      {...dropZoneProps}
    />
  );
};
